import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\AddAssignedPersonToMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedPersonToMaterialResourceController.php
* @route '/api/planning/{event}'
*/
const AddAssignedPersonToMaterialResourceController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddAssignedPersonToMaterialResourceController.url(args, options),
    method: 'post',
})

AddAssignedPersonToMaterialResourceController.definition = {
    methods: ["post"],
    url: '/api/planning/{event}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\AddAssignedPersonToMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedPersonToMaterialResourceController.php
* @route '/api/planning/{event}'
*/
AddAssignedPersonToMaterialResourceController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return AddAssignedPersonToMaterialResourceController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\AddAssignedPersonToMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedPersonToMaterialResourceController.php
* @route '/api/planning/{event}'
*/
AddAssignedPersonToMaterialResourceController.post = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddAssignedPersonToMaterialResourceController.url(args, options),
    method: 'post',
})

export default AddAssignedPersonToMaterialResourceController